<button 
    mat-icon-button 
    matTooltip="Support Links"
    (click)="supportLinksDrawer.toggle()" 
    #supportLinksButton>
    <mat-icon class="icon-size-6" [svgIcon]="'heroicons_outline:question-mark-circle'"></mat-icon>
</button>

<davesa-drawer 
    class="z-999 w-screen min-w-screen sm:w-100 sm:min-w-100" 
    fixed 
    [mode]="'over'"
    [name]="'supportLinksDrawer'" 
    [position]="'right'" 
    #supportLinksDrawer>
    <div class="bg-card flex w-full flex-col overflow-auto h-full">
        <!-- Header -->
        <div class="support-links-header flex flex-0 cursor-pointer items-center justify-start bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 p-4">
            <div class="flex flex-auto items-center justify-center">
                <div class="flex w-16 flex-0 items-center justify-center">
                    <mat-icon class="icon-size-8 m-1 text-primary-500" [svgIcon]="'heroicons_outline:question-mark-circle'"></mat-icon>
                </div>
                <div class="text-secondary text-lg font-medium">
                    Support Links
                </div>
                <button class="ml-auto mr-4" mat-icon-button (click)="supportLinksDrawer.close()">
                    <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                </button>
            </div>
        </div>
        
        <!-- Content -->
        <div class="flex flex-auto flex-col overflow-hidden bg-gray-50 dark:bg-transparent">
            <div class="h-full w-full flex-0 overflow-y-auto overscroll-y-contain p-6"
                davesaScrollbar [davesaScrollbarOptions]="{ wheelPropagation: false }">
                
                <!-- Support Categories Grid -->
                <div class="support-links-grid grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    <div 
                        *ngFor="let link of supportLinks; trackBy: trackByFn"
                        class="support-link-card bg-card rounded-lg shadow hover:shadow-lg transition-shadow duration-200 cursor-pointer border border-gray-200 dark:border-gray-700"
                        (click)="openSupportLink(link.url)">
                        <div class="flex flex-col items-center justify-center p-6 space-y-3">
                            <mat-icon 
                                class="icon-size-12 text-primary-500" 
                                [svgIcon]="link.icon">
                            </mat-icon>
                            <div class="text-center text-sm font-medium text-gray-700 dark:text-gray-300">
                                {{ link.title }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Description -->
                <div class="mt-6 p-4 bg-blue-50 dark:bg-gray-800 rounded-lg border border-blue-200 dark:border-gray-700">
                    <p class="text-sm text-gray-600 dark:text-gray-400 text-center">
                        We are committed to providing prompt and effective assistance to ensure your continued success with the Davesa platform.
                    </p>
                </div>
            </div>
        </div>
    </div>
</davesa-drawer>
